import React, { useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import { TooltipState } from "../../constants";

interface TooltipWithClickAwayProps {
  tooltipText: string;
  tooltipKey: string;
  usePortal?: boolean;
}

const TooltipWithClickAway: React.FC<TooltipWithClickAwayProps> = ({
  tooltipText,
  tooltipKey,
  usePortal = false,
}) => {
  // Declare a new state variable for tooltips with a default empty object
  const [openTooltip, setOpenTooltip] = useState<TooltipState>({});

  // Function to handle tooltip close
  const tooltipClose = (id: string) => {
    setOpenTooltip((prev) => ({ ...prev, [id]: false }));
  };

  // Function to handle tooltip open
  const tooltipOpen = (id: string) => {
    setOpenTooltip((prev) => ({ ...prev, [id]: true }));
  };
  return (
    <ClickAwayListener onClickAway={() => tooltipClose(tooltipKey)}>
      <Tooltip
        PopperProps={{
          disablePortal: !usePortal,
        }}
        onClose={() => tooltipClose(tooltipKey)}
        open={openTooltip[tooltipKey] || false}
        disableFocusListener
        disableTouchListener
        title={tooltipText}
      >
        <InfoIcon
          data-testid="info-icon"
          className="info-icon"
          onMouseEnter={() => tooltipOpen(tooltipKey)}
          onMouseLeave={() => tooltipClose(tooltipKey)}
        />
      </Tooltip>
    </ClickAwayListener>
  );
};

export default TooltipWithClickAway;
